import loadable from '@loadable/component'

export const SearchResults = loadable(() => import('./SearchResults'))
export const QuickSearchFilters = loadable(() => import('./QuickSearchFilters'))

export const SearchResultsColumn = loadable(
  () => import('./SearchResultsColumn')
)
export const SearchResultsPageColumn = loadable(
  () => import('./SearchResultsPageColumn')
)
export type { SearchResultsProps, Constants } from './SearchResults'
export type {
  SearchResultPageItemProps,
  SearchResultsPageColumnProps
} from './SearchResultsPageColumn'
export type {
  SearchResultItemProps,
  SearchResultsColumnProps
} from './SearchResultsColumn'
